export const EVENT_TRACKING_PAGE_CONST = {
    localStorage: {
        sidebarCollapseKey: 'eventTrackingSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
